import { render, staticRenderFns } from "./TabelaResultadosCargosUsuario.vue?vue&type=template&id=47fb9078&scoped=true&"
import script from "./TabelaResultadosCargosUsuario.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosCargosUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosCargosUsuario.vue?vue&type=style&index=0&id=47fb9078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb9078",
  null
  
)

export default component.exports